/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import Slider from "react-slick";
import styled from "styled-components";
import { BRAND_SLIDE_SLICK } from "../../../config/slide";
import { Title } from "../Contestant/Contestant";
import { NumberText } from "../group/Introduce";

export default class SectionBrand extends Component {
  next = () => {
    this.slider.slickNext();
  };

  previous = () => {
    this.slider.slickPrev();
  };

  render() {
    return (
      <Styles className="section-brand">
        <div className="bs-container">
          <NumberText style={{ color: "#111423" }}>03</NumberText>
          <h2>ĐỐI TÁC KHÁCH HÀNG</h2>
          <div className="bs-row">
            <div className="bs-col">
              <div className="module module-brand">
                <div className="module-content">
                  {/* <div className="brand-control">
                    <button
                      className="brand__btn next__btn"
                      onClick={this.previous}
                      type="button"
                    />
                    <button
                      className="brand__btn prev__btn"
                      onClick={this.next}
                      type="button"
                    />
                  </div> */}

                  {/* <Slider
                    ref={(c) => (this.slider = c)}
                    {...BRAND_SLIDE_SLICK}
                    className="brand-slide"
                    data-aos="fade-up"
                  > */}
                  <div className="slide-wrap">
                    <div className="slide-item">
                      <div className="item">
                        <img src="/images/slice-1.png" alt="" />
                      </div>
                    </div>
                    <div className="slide-item">
                      <div className="item">
                        <img src="/images/slice-2.png" alt="" />
                      </div>
                    </div>

                    <div className="slide-item">
                      <div className="item">
                        <img src="/images/slice-3.png" alt="" />
                      </div>
                    </div>
                    <div className="slide-item">
                      <div className="item">
                        <img src="/images/slice-4.png" alt="" />
                      </div>
                    </div>
                    <div className="slide-item">
                      <div className="item">
                        <img src="/images/slice-5.png" alt="" />
                      </div>
                    </div>
                    <div className="slide-item">
                      <div className="item">
                        <img src="/images/slice-6.png" alt="" />
                      </div>
                    </div>
                    <div className="slide-item">
                      <div className="item">
                        <img src="/images/slice-7.png" alt="" />
                      </div>
                    </div>

                    <div className="slide-item">
                      <div className="item">
                        <img src="/images/slice-8.png" alt="" />
                      </div>
                    </div>
                    {/* <div className="slide-item">
                      <div className="item">
                        <img src="/images/slice-9.png" alt="" />
                      </div>
                    </div> */}
                    <div className="slide-item">
                      <div className="item">
                        <img src="/images/slice-10.png" alt="" />
                      </div>
                    </div>
                    <div className="slide-item">
                      <div className="item">
                        <img src="/images/slice-11.png" alt="" />
                      </div>
                    </div>
                    <div className="slide-item">
                      <div className="item">
                        <img src="/images/slice-12.png" alt="" />
                      </div>
                    </div>
                  </div>
                  {/* </Slider> */}
                </div>
              </div>
            </div>
          </div>
          <h2 className="partner-label">ĐỐI TÁC TRUYỀN THÔNG</h2>
          <div className="partner-cover">
            <img src="/images/partner-1.png" alt="" />
            <img src="/images/partner-2.png" alt="" />
            <img src="/images/partner-3.png" alt="" />
            <img src="/images/partner-4.png" alt="" />
          </div>
        </div>
      </Styles>
    );
  }
}

const Styles = styled.section`
  padding: 0;
  &.section-brand .module-brand .module-content .brand-control .brand__btn {
    top: 50%;
  }

  &.section-brand .module-brand .module-content {
    padding: 0;
  }

  &.section-brand .module-brand .module-content .item {
    background: white;
    border-radius: 8px;
    height: 80px;
  }

  h2 {
    margin: 0 0 40px;
    font-size: 40px;
    font-weight: 700;
  }

  .slide-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    > * {
      width: 15%;
    }
    gap: 15px;
    img {
      max-width: 100%;
      width: 100%;
    }

    .slide-item {
      padding: 0 !important;
    }
  }

  .partner-label {
    margin-top: 40px;
  }

  .partner-cover {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    img {
      max-height: 94px;
      max-width: 23%;
    }
  }

  @media only screen and (max-width: 991px) {
    .slide-wrap {
      > * {
        width: 20%;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    &.section-brand .module-brand .module-content .item {
      height: 60px;
    }
    .slide-wrap {
      > * {
        width: 20%;
      }
    }
  }

  @media only screen and (max-width: 480px) {
    h2 {
      font-size: 28px;
    }
    .partner-cover {
      gap: 15px;
    }
  }
`;
